(function () {
  function getMinimumQuantity(input) {
    return Number(input.dataset.minimumOrderQuantity || input.getAttribute('min') || 1);
  }

  function isMinimumQuantityInput(input) {
    return (
      input &&
      input.matches('input[type="number"][data-minimum-order-quantity]') &&
      getMinimumQuantity(input) > 1
    );
  }

  function enforceMinimum(input) {
    if (!isMinimumQuantityInput(input)) return;

    var minimumQuantity = getMinimumQuantity(input);
    var currentValue = Number(input.value);

    if (!input.value || currentValue < minimumQuantity || !Number.isInteger(currentValue)) {
      input.value = minimumQuantity;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function enforceAllMinimums() {
    document
      .querySelectorAll('input[type="number"][data-minimum-order-quantity]')
      .forEach(function (input) {
        enforceMinimum(input);
      });
  }

  /*
    Do NOT enforce on input.
    The user must be able to delete "2" and type "4" without it becoming "24".
  */

  document.addEventListener(
    'blur',
    function (event) {
      var input = event.target.closest('input[type="number"][data-minimum-order-quantity]');
      if (!input) return;

      enforceMinimum(input);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target.closest('input[type="number"][data-minimum-order-quantity]');
      if (!input) return;

      enforceMinimum(input);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      var input = event.target.closest('input[type="number"][data-minimum-order-quantity]');
      if (!input) return;

      if (['e', 'E', '+', '-', '.', ','].includes(event.key)) {
        event.preventDefault();
        return;
      }

      if (event.key === 'Enter') {
        enforceMinimum(input);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (
        event.target.closest('.js-quantity-btn') ||
        event.target.closest('.js-cart-drawer-quantity-btn') ||
        event.target.closest('[name="minus"]') ||
        event.target.closest('[name="plus"]')
      ) {
        setTimeout(enforceAllMinimums, 30);
        setTimeout(enforceAllMinimums, 150);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function () {
      enforceAllMinimums();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (
        event.target.closest('button[name="checkout"]') ||
        event.target.closest('button[name="update"]') ||
        event.target.closest('button[type="submit"]') ||
        event.target.closest('a[href="/checkout"]')
      ) {
        enforceAllMinimums();
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', enforceAllMinimums);
  document.addEventListener('shopify:section:load', enforceAllMinimums);

  document.addEventListener('cart:updated', enforceAllMinimums);
  document.addEventListener('cart:refresh', enforceAllMinimums);
  document.addEventListener('cart:change', enforceAllMinimums);
})();